import { render, staticRenderFns } from "./DataBuild.vue?vue&type=template&id=7cc0af26&scoped=true&"
import script from "./DataBuild.vue?vue&type=script&lang=js&"
export * from "./DataBuild.vue?vue&type=script&lang=js&"
import style0 from "./DataBuild.vue?vue&type=style&index=0&id=7cc0af26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0af26",
  null
  
)

export default component.exports